import { Spinner } from '@schibsted-svp/react-ui';

import css from './LiveCreationDialogSpinner.module.scss';

function LiveCreationDialogSpinner() {
    return <Spinner containerClassName={css.spinner} />;
}

export default LiveCreationDialogSpinner;
